import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartProjectPaths } from '@cli-types/next-adapter/config.js'
import { trimDotSlash } from '@cli-utils/paths.js'
import { resolveAdminNamespace } from '@next-adapter/config/namespace/resolve-admin-namespace.js'

export function resolveProjectPaths(config: ResolvedBetterstartConfig): BetterstartProjectPaths {
  const namespace = resolveAdminNamespace(config.frameworkConfig.next.namespace)
  const adminDir = trimDotSlash(config.paths?.admin ?? './admin')
  const pagesDir = trimDotSlash(config.paths?.pages ?? './src/app/(admin)/admin/(authenticated)')
  const schemasDir = trimDotSlash(config.paths?.schemas ?? './admin/schemas')
  const adminDbDir = path.posix.join(adminDir, 'lib', 'db')
  const adminDbCoreDir = path.posix.join(adminDbDir, 'core')
  const adminUtilsAppDir = path.posix.join(adminDir, 'utils', 'app')
  const adminTypesDir = path.posix.join(adminDir, 'types')
  const adminNavigationFile = path.posix.join(adminDir, 'data', 'navigation.ts')
  const adminNavigationDir = path.posix.join(adminDir, 'data', 'navigation')
  const adminWebhookEventsFile = path.posix.join(adminDir, 'data', 'webhook-events.ts')
  const adminWebhookEventsDir = path.posix.join(adminDir, 'data', 'webhook-events')
  const adminActionsDir = path.posix.join(adminDir, 'lib', 'actions')

  return {
    adminDir,
    pagesDir,
    schemasDir,
    adminDbDir,
    adminDbCoreDir,
    adminDbCoreFile: path.posix.join(adminDbCoreDir, 'schema.ts'),
    adminDbSchemaFile: path.posix.join(adminDbDir, 'schema.ts'),
    adminUtilsAppDir,
    adminTypesDir,
    adminDataFile: path.posix.join(adminUtilsAppDir, `${namespace.camel}.ts`),
    adminDataNavigationFile: adminNavigationFile,
    adminTypesNavigationFile: path.posix.join(adminTypesDir, 'navigation.ts'),
    adminNavigationFile,
    adminNavigationDir,
    adminWebhookEventsFile,
    adminWebhookEventsDir,
    adminActionsDir,
    adminEmailTemplatesDir: path.posix.join(adminDir, 'components', 'email-templates'),
    adminHooksDir: path.posix.join(adminDir, 'hooks')
  }
}
